import React from 'react'

/**
 * The enclosing section's runtime id. The field shell reads it when registering a focus
 * target so the wizard can jump to the owning section before focusing. Undefined outside a section.
 */
export const UI2FormSectionIdContext = React.createContext<string | undefined>(undefined)
